export const fetchOrderHistoryDetail = (state: Object, action: Object) => {
  const { orderId } = action.payload;

  return {
    ...state,
    [orderId]: {
      ...state[orderId],
      isFetching: true,
      isOpen: true,
    },
  };
};

export const fetchOrderHistoryOrderDetailsSuccess = (
  state: Object,
  action: Object
) => ({
  ...state,
  [action.payload.orderId]: {
    ...state[action.payload.orderId],
    isFetching: false,
    isError: false,
  },
});

export const orderHistoryDetailToggle = (state: Object, action: Object) => {
  const { orderId } = action.payload;
  return {
    ...state,
    [orderId]: { ...state[orderId], isOpen: !state[orderId].isOpen },
  };
};

